import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LocationsHero } from '../components/locations/LocationsHero';
import { LocationGrid } from '../components/locations/LocationGrid';
import { CTASection } from '../components/home/CTASection';
export function LocationsPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-982">
      <Header data-id="element-983" />

      <main className="pt-20" data-id="element-984">
        <LocationsHero data-id="element-985" />
        <LocationGrid data-id="element-986" />
        <CTASection data-id="element-987" />
      </main>

      <Footer data-id="element-988" />
    </div>;
}